import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { FilterDefault } from './filter-default';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ng2-smart-table-filter',
    styleUrls: ['./filter.component.scss'],
    template: `
    <div
      class="ng2-smart-filter"
      *ngIf="column.isFilterable"
      [ngSwitch]="column.getFilterType()"
    >
      <custom-table-filter
        *ngSwitchCase="'custom'"
        [query]="query"
        [column]="column"
        [source]="source"
        [inputClass]="inputClass"
        (filter)="onFilter($event)"
      >
      </custom-table-filter>
      <default-table-filter
        *ngSwitchDefault
        [query]="query"
        [column]="column"
        [source]="source"
        [inputClass]="inputClass"
        (filter)="onFilter($event)"
      >
      </default-table-filter>
    </div>
  `,
    standalone: false
})
export class FilterComponent extends FilterDefault implements OnChanges {
  query: string = '';
  protected dataChangedSub: Subscription;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.source) {
      if (!changes.source.firstChange) {
        this.dataChangedSub.unsubscribe();
      }
      this.dataChangedSub = this.source.onChanged().subscribe(dataChanges => {
        const filterConf = this.source.getFilter();
        if (
          filterConf &&
          filterConf.filters &&
          filterConf.filters.length === 0
        ) {
          this.query = '';

          // add a check for existing filters an set the query if one exists for this column
          // this covers instances where the filter is set by user code while maintaining existing functionality
        } else if (
          filterConf &&
          filterConf.filters &&
          filterConf.filters.length > 0
        ) {
          filterConf.filters.forEach((k: any, v: any) => {
            if (k.field === this.column.id) {
              // In case use filter then click to another page, then click "back" button on browser, we need to retrive old filter
              // Note: In case user continue typing on the time data has been returned from server, the filter textbox will be re-update.
              // To keep the latest text which user typed, we will only reset query value in case query is null or empty.
              if (this.query != null && this.query.trim() == '') {
                this.query = k.search;
              }
              this.column.cached = k.cached;
            }
          });
        }
      });
    }
  }
}
